import { Icon } from '@dynamic/ui';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

export const ErrorMessage: FC<{ children?: ReactNode }> = ({ children }) => (
  <StyledMessage data-testid="error-message">
    <StyledIcon name="info_circle" />
    {children}
  </StyledMessage>
);

const StyledMessage = styled.div`
  margin: 0.1rem 0 0;
  font: var(--fontStyleCaption1);
  color: var(--pageParagraphForeground);
  text-align: left;
`;

const StyledIcon = styled(Icon)`
  margin: -0.2rem 0.15rem 0 0;
  vertical-align: middle;
  width: 1.2em;
  height: 1.2em;
  color: var(--inputValidation);
`;
